import { useState, useEffect, useCallback, useMemo } from 'react'
import { useParams } from 'react-router'
import useRouter from 'utils/useRouter'
import { useUsuarioService } from 'hooks/useUsuarioService'
import { useVestigioService } from 'hooks/useVestigioService'

export const useDescartarVestigio = () => {
  const router = useRouter()
  const params = useParams()
  const usuarioService = useUsuarioService()
  const vestigioService = useVestigioService()

  const [dataCadastroVestigio, setDataCadastroVestigio] = useState(null)
  const [usuarios, setUsuarios] = useState([])
  const [processando, setProcessando] = useState(false)
  const [modalConfirmacao, setModalConfirmacao] = useState(false)

  const [values, setValues] = useState({
    autorizacaousuario: null,
    autorizacaodata: new Date(),
    autorizacaonumero: '',
    observacoes: '',
  })

  const [autorizadoUsuarioObj, setAutorizadoUsuarioObj] = useState(null)

  const fetchVestigio = useCallback(async () => {
    try {
      const vestigio = await vestigioService.listarVestigioAsync(params.id)
      setDataCadastroVestigio(vestigio?.createdAt || null)
    } catch (error) {
      console.error('Erro ao buscar vestígio:', error)
    }
  }, [params.id])

  const fetchUsuarios = useCallback(async () => {
    try {
      const response = await usuarioService.listarUsuarios()
      setUsuarios(response || [])
    } catch (error) {
      console.error('Erro ao listar usuários:', error)
      setUsuarios([])
    }
  }, [usuarioService])

  useEffect(() => {
    fetchVestigio()
    fetchUsuarios()
  }, [fetchVestigio, fetchUsuarios])

  const handleChangeAutorizadoUsuario = useCallback((event, newValue) => {
    setAutorizadoUsuarioObj(newValue)
    setValues((prev) => ({
      ...prev,
      autorizacaousuario: newValue?.id || null,
    }))
  }, [])

  const handleChangeWithModification = useCallback((event, modification) => {
    event.persist()
    const { name, value } = event.target
    setValues((prev) => ({
      ...prev,
      [name]: modification(value),
    }))
  }, [])

  const setDataAutorizacao = useCallback((data) => {
    setValues((prev) => ({
      ...prev,
      autorizacaodata: data,
    }))
  }, [])

  const fecharModalConfirmacao = useCallback(() => {
    setModalConfirmacao(false)
  }, [])

  const abrirModalConfirmacao = useCallback(() => {
    setModalConfirmacao(true)
  }, [])

  const descartarVestigio = useCallback(async () => {
    const dados = {
      id_usuario_autorizacao_descarte: values.autorizacaousuario,
      numeroAutorizacaoDescarte: values.autorizacaonumero,
      dataAutorizacaoDescarte: values.autorizacaodata,
      observacoesDescarte: values.observacoes,
    }

    try {
      setProcessando(true)
      await vestigioService.descartarVestigio(params.id, dados, setProcessando)
      setModalConfirmacao(false)
      router.history.push(`/casos/caso/vestigio/detalhar/${params.id}`)
    } catch (error) {
      console.error('Erro ao descartar vestígio:', error)
    } finally {
      setProcessando(false)
    }
  }, [params.id, values, router])

  const isFormValid = useMemo(() => {
    return !!(
      values.autorizacaousuario &&
      values.autorizacaonumero?.trim() &&
      values.autorizacaodata
    )
  }, [values])

  return {
    values,
    autorizadoUsuarioObj,
    usuarios,
    dataCadastroVestigio,
    processando,
    modalConfirmacao,
    handleChangeAutorizadoUsuario,
    handleChangeWithModification,
    setDataAutorizacao,
    fecharModalConfirmacao,
    abrirModalConfirmacao,
    descartarVestigio,
    isFormValid,
    router,
    params,
  }
}
